import { Deserializable } from '@app/shared/interfaces/deserializable.interface';

export class DeserializableModel implements Deserializable {
  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
